import vars from '../helpers';
import '../mixpanel';
import {trackEmail, trackPassword, trackRegister} from '../mixpanel';

const $signInputEmail = document.querySelector('#email') || false;
const $signInputPassword = document.querySelector('#password') || false;
const $signSubmit = document.querySelector('.sign__submit') || false;

const getUrlVars = () => {
	var array = [],
		hash;
	var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
	for (var i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=');
		array.push(hash[0]);
		array[hash[0]] = hash[1];
	}
	return array;
};

const submit = async function registerOnShugar(data, lending_number) {
	const res = await fetch('https://api.shugar.ai/user-service/register', {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'Content-Type': 'application/json',
		},
	});

	const resData = await res.json();

	try {
		const goal = 1;
		const res = await fetch(
			`https://offers-shugarai.affise.com/postback?clickid=${data.click_id}&goal=${goal}`,
			{
				mode: 'no-cors',
			},
		);
		console.log(`Postback response for ${data.click_id}:`, res);
	} catch (e) {
		console.error('Postback error:', e);
	}

	trackRegister();

	setTimeout(() => {
		window.location.href = `https://shugar.ai/api/authorize?token=${resData.refresh_token}`;
	}, 500);
};

const validation = () => {
	if (!vars.regexEmail.test($signInputEmail.value)) {
		$signInputEmail.closest('.sign__label').classList.add('is-error');
	}

	if ($signInputPassword.value.length < 4) {
		$signInputPassword.closest('.sign__label').classList.add('is-error');
	}
};

const init = () => {
	if (!$signInputEmail) {
		return;
	}

	document.getElementById('email').onblur = (event) => trackEmail(event.target.value);
	document.getElementById('password').onblur = () => trackPassword();

	$signInputEmail.addEventListener('input', () => {
		let label = $signInputEmail.closest('.sign__label');

		if ($signInputEmail.value && $signInputPassword.value) {
			$signSubmit.removeAttribute('disabled');
		} else {
			$signSubmit.setAttribute('disabled', 'disabled');
		}

		if (label.classList.contains('is-error')) {
			label.classList.remove('is-error');
		}
	});

	$signInputPassword.addEventListener('input', () => {
		let label = $signInputPassword.closest('.sign__label');

		if ($signInputEmail.value && $signInputPassword.value) {
			$signSubmit.removeAttribute('disabled');
		} else {
			$signSubmit.setAttribute('disabled', 'disabled');
		}

		if (label.classList.contains('is-error')) {
			label.classList.remove('is-error');
		}
	});

	$signSubmit.addEventListener('click', (e) => {
		e.preventDefault();

		if (vars.regexEmail.test($signInputEmail.value) && $signInputPassword.value) {
			let formData = {
				email: $signInputEmail.value,
				password: $signInputPassword.value,
				click_id: getUrlVars()['clickId'] || 'default_click_id',
				offer_id: getUrlVars()['offerId'] || 'default_offer_id',
				affiliate_id: getUrlVars()['affiliateId'] || 'default_affiliate_id',
				gender: 'unset',
			};

			submit(formData, '10');
		} else {
			validation();
		}
	});
};

export default {
	init,
};
